module.exports = __webpack_public_path__ + "static/media/GW.396d6bbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GW.svg
// module id = 2165
// module chunks = 7